import { EyeOff } from 'lucide-react';
import { formatDate, timeAgo } from '../../lib/utils';

interface ClientViewedCellProps {
	/** Client-side only — an admin opening the quote never stamps this. */
	lastClientViewedAt?: string | null;
	clientViewCount: number;
}

/**
 * Whether the client has opened the quote in the portal — a client user or a
 * guest-link visitor. Portal views only, so it is not evidence the offer email
 * was opened.
 *
 * Reports the fact and nothing more: null means they have not opened it,
 * whatever stage the quote is at. Whether that is worth chasing depends on
 * whether an offer has actually reached them, which is the neighbouring status
 * column's job to say — not something to re-derive from the status here.
 */
export function ClientViewedCell({ lastClientViewedAt, clientViewCount }: ClientViewedCellProps) {
	if (!lastClientViewedAt) {
		return (
			<span className="inline-flex items-center gap-1.5 text-base text-text-4">
				<EyeOff size={12} />
				Not viewed
			</span>
		);
	}
	return (
		<span
			className="text-base text-text-3"
			title={`${formatDate(lastClientViewedAt)} · ${
				clientViewCount === 1 ? '1 view' : `${clientViewCount} views`
			}`}
		>
			{timeAgo(lastClientViewedAt)}
		</span>
	);
}
